import { render, staticRenderFns } from "./ExamineResearch.vue?vue&type=template&id=dcbbc308&scoped=true"
import script from "./ExamineResearch.vue?vue&type=script&lang=ts"
export * from "./ExamineResearch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcbbc308",
  null
  
)

export default component.exports